import { Link } from "react-router-dom";
import { brand, nav, contact } from "../data/site";
import SocialIcons from "./SocialIcons";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gold/15 bg-charcoal text-cream">
      <div className="container-luxe grid gap-12 py-16 md:grid-cols-3 lg:gap-10">
        {/* Brand */}
        <div className="flex flex-col items-start gap-6">
          <img src={brand.logoWhite} alt={brand.name} className="h-14 w-auto" />
          <p className="max-w-xs font-serif text-lg font-light leading-relaxed text-cream/70">
            {brand.tagline}. Antique gold jewellery, hand-crafted in Ahmedabad to
            be treasured for generations.
          </p>
          <SocialIcons />
        </div>

        {/* Explore */}
        <div>
          <h4 className="eyebrow mb-6 text-gold-light">Explore</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/" className="font-serif text-xl text-cream/80 transition-colors hover:text-gold-light">
                Home
              </Link>
            </li>
            {nav.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="font-serif text-xl text-cream/80 transition-colors hover:text-gold-light"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Visit */}
        <div>
          <h4 className="eyebrow mb-6 text-gold-light">Visit &amp; Enquire</h4>
          <address className="not-italic">
            <p className="font-serif text-lg leading-relaxed text-cream/80">
              {contact.addressLines.map((line) => (
                <span key={line} className="block">
                  {line}
                </span>
              ))}
            </p>
            <div className="mt-5 space-y-2 font-sans text-sm tracking-wide text-cream/70">
              <a href={`tel:${contact.phone.replace(/\s/g, "")}`} className="block hover:text-gold-light">
                {contact.phone}
              </a>
              <a href={`mailto:${contact.email}`} className="block hover:text-gold-light">
                {contact.email}
              </a>
              <p className="text-cream/50">{contact.hours}</p>
            </div>
          </address>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-luxe flex flex-col items-center justify-between gap-3 py-6 text-center sm:flex-row sm:text-left">
          <p className="font-sans text-xs tracking-wide text-cream/40">
            © {year} {brand.legalName}. All rights reserved.
          </p>
          <p className="font-sans text-xs tracking-wide text-cream/40">
            Crafted in Ahmedabad · Since generations
          </p>
        </div>
      </div>
    </footer>
  );
}
